/**
 * @deprecated Import from '../core/models' instead.
 * This file re-exports for backward compatibility during migration.
 */
export {
  ColumnType,
  ChildTableColumn,
  SelectOption,
  ValidationRule,
  ChildTableRow,
  SortConfig,
  FilterOperator,
  FilterConfig,
  EditingCell,
  ChildTableConfig,
  ChildTableState,
  ChildTableEvents,
  RowActionId,
  RowActionItem,
  NAVIGATION_KEYS,
  KEYBOARD_SHORTCUTS,
} from '../core/models/table.models';

export {
  CellPosition,
  CellRange,
  normalizeRange,
  CoerceResult,
  AlertModalConfig,
} from '../core/models/cell.models';
